export const Orientation = {
		Is_PORTRAIT: 'portrait',
		Is_LANDSCAPE: 'landscape'
}
